// src/packages/frontend/src/pages/subscription-detail/form/component.tsx
import { Form } from '@/components/forms';
import { Alert, Checkbox, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { FormikProps } from 'formik';
import * as yup from 'yup';

const validationSchema = yup.object({
	isParticipatingInPrizeDraw: yup.boolean().required(),
	isOver18: yup.boolean().when('isParticipatingInPrizeDraw', {
		is: true,
		then: (schema) => schema.isTrue('You must be over 18 to participate in the prize draw'),
		otherwise: (schema) => schema.notRequired(),
	}),
});

export type SubscriptionFormValues = {
	isParticipatingInPrizeDraw: boolean;
	isOver18: boolean;
};

type SubscriptionFormProps = {
	onSubmit: (values: SubscriptionFormValues) => void;
	formRef: React.RefObject<FormikProps<SubscriptionFormValues>>;
	priceInterval: string;
	initialValues: SubscriptionFormValues;
};

export const SubscriptionForm = ({ onSubmit, formRef, initialValues }: SubscriptionFormProps) => {
	return (
		<Form
			initialValues={initialValues}
			onSubmit={onSubmit}
			innerRef={formRef}
			validationSchema={validationSchema}
		>
			{({ values, setFieldValue, touched, errors }) => (
				<>
					<Checkbox
						label="I wish to participate in the prize draw."
						checked={values.isParticipatingInPrizeDraw}
						onChange={(e) => setFieldValue('isParticipatingInPrizeDraw', e.currentTarget.checked)}
						error={touched.isParticipatingInPrizeDraw && errors.isParticipatingInPrizeDraw}
					/>
					<Checkbox
						label="I am over 18 years of age."
						checked={values.isOver18}
						onChange={(e) => setFieldValue('isOver18', e.currentTarget.checked)}
						error={touched.isOver18 && errors.isOver18}
					/>
					<Alert icon={<IconAlertCircle />} variant="filled" bg="red.2" mb="md">
						<Text size="sm">
							To be eligible for prize draw, the primary account holder needs to be over 18 yrs of
							age.
						</Text>
					</Alert>
				</>
			)}
		</Form>
	);
};
